import JSEncrypt from 'jsencrypt'; // 引入 jsencrypt
import { getRsaPublicKey } from './WebConfig';
export enum ProductModelType {
    DEV = 'DEV',//本地
    SANDBOX = 'SANDBOX',//沙盒
    PROD = 'PROD',//生产
}
class RsaBase {
    /// dev
//     static publicKey: string = `-----BEGIN PUBLIC KEY-----
// MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAoUHQuwPC8cBocoT4cb4I
// jwY8fdJXp6o7RLrINOEVU4tNQCIg8d+9+FoSWHtd+LK9fSgSRZA3bzdAw/I7c34H
// CoKzjRa29NOfnmabYx7lKN7zzr/nyulp/V9c5PXhOoWygQSAkJcCCDtWZ4fiIsXc
// JADZv5/q6RmRe8IeDpSMZn1PdndRbfKVODN06FkxuKCiqMr2oBOI1qorTZFn2ABd
// Nvda3WR6WtALcvaZ4nDOEoNzBMBo1KHHHRjHMf71T7o3+fFvLzgXWmWxQscFo4F7
// l91PRZtOEP2q1PtaUfyXPWKX1aMZUYLwCtYctBo3H7HhNF0HKOecx18/SSqTdKwC
// 5wIDAQAB
// -----END PUBLIC KEY-----`;
    static publicKey: string = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA1JqqxPLNWEy371X+kOXq
wE8fMebohqHI9txXRoUIh28dYsrv85JTrknLlPcYWT5Q27nHGcywu8hpsjMwe1U2
akHikIzLYEu/8GaGqI7qHa+73F54lVKHBcwdK8PjH8+o76kN9MsouJ8QA7Nk0g4u
6equEzyrchwjr/bOjP4MhPt4hU90jpQbp3tqDu6PQgPQZzxDtIX9TeqzplCAYNy2
M4i1HtbZk2a9vimFqTsM8i+ALPH47c+Bt4b4mLoKqSyF6K1muhV/kqfecV8fvyfN
bkJdUkWQnNvgTX0f1nhAshArLMw4VyROrYBAamFgtzwRpC4qCYhBzWqyhb10bEEf
XwIDAQAB
-----END PUBLIC KEY-----`;

     /// prod
    static publicProdKey: string = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAsPNoWVCbeuzhPbKrubO7
mMqz2d3R+mgtBP+ogq+sT11H7wm2EJaspBrMyjMnQMz8b3/iAyPy3xrBW7wwcmTm
UWrLeAZvZouTJ5/Jv1DrNMRJoKmt+7kHZIcovrKDTSOyWos7GCJ/XDkWYClRXAk8
4S5zcr8Fk+XzH+nUVMpNj9GrTjmaDe4ty7qhxW4Ce8e+xoUq1qCigp5dqZ0TG+sf
aT4bwoB3OhKdQRPEhF2nILr0zao+xaX+MKChGeSK061vqqQgrGh4rd3Y8/R4o8BN
Gl4I6LGSm/bs4mqnCkgEEBe36ADWj6hy6dPLgGhO2NCXl2MZ6H75sJmrVMaubPGJ
WQIDAQAB
-----END PUBLIC KEY-----`;


    // RSA 加密方法
    static encryptData(value: string): string | null {
        const publicKey = (getRsaPublicKey() === ProductModelType.DEV) || (getRsaPublicKey() === ProductModelType.SANDBOX) ? this.publicKey : this.publicProdKey;
        try {
            const encrypt = new JSEncrypt();
            encrypt.setPublicKey(publicKey);
            const encrypted = encrypt.encrypt(value);
            if (!encrypted) {
                console.error('Encryption failed');
                return null;
            }
            console.log('encrypted', encrypted);
            return encrypted;
        } catch (error) {
            console.error('Encryption error:', error);
            return null;
        }
    }
}

export default RsaBase;
